<div class="pub-guide-user" [@guide]>
    <manual-tab></manual-tab>
    <!--<mat-tab-group>-->
    <!-- <mat-tab label="Guía de uso">
            <guide-tab></guide-tab>
        </mat-tab>-->
    <!--<mat-tab label="">
            <manual-tab></manual-tab>
        </mat-tab>-->
    <!--<mat-tab label="Accesibilidad web">yy
            <accesibility-tab></accesibility-tab>
        </mat-tab>-->
    <!--- </mat-tab-group>-->
</div>
